import React from 'react';
import { Enviroment } from '../../../../_config/constants/enviroment-v2.constant';
import { dictionaryProductColumn } from '../constants/dictionary-product-columns.constant';

export const generateProductColumns = () => {
	const formatPrice = (price) => {
		return new Intl.NumberFormat('es-CL', {
			style: 'currency',
			currency: 'CLP',
			minimumFractionDigits: 0,
		}).format(price || 0);
	};

	return [
		{
			title: dictionaryProductColumn[Enviroment.LANGUAGE].name,
			dataIndex: 'name',
			key: 'name',
			render: (text, record) => (
				<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
					{record.image && (
						<img 
							src={record.image} 
							alt={text} 
							style={{ width: 40, height: 40, objectFit: 'cover', borderRadius: 4 }} 
						/>
					)}
					<span>{text}</span>
				</div>
			),
		},
		{
			title: dictionaryProductColumn[Enviroment.LANGUAGE].quantity,
			dataIndex: 'quantity',
			key: 'quantity',
			width: 80,
			align: 'center',
		},
		{
			title: dictionaryProductColumn[Enviroment.LANGUAGE].unit_price,
			dataIndex: 'unit_price',
			key: 'unit_price',
			width: 120,
			render: (value) => formatPrice(value),
		},
		{
			title: dictionaryProductColumn[Enviroment.LANGUAGE].disscount,
			dataIndex: 'discount',
			key: 'discount',
			width: 100,
			render: (value) => formatPrice(value),
		},
		{
			title: dictionaryProductColumn[Enviroment.LANGUAGE].total,
			dataIndex: 'final_price',
			key: 'final_price',
			width: 120,
			render: (value) => formatPrice(value),
		},
		{
			title: dictionaryProductColumn[Enviroment.LANGUAGE].recipe,
			dataIndex: 'recipe',
			key: 'recipe',
			width: 100,
			render: (url) => url ? (
				<a href={url} target="_blank" rel="noopener noreferrer">Ver receta</a>
			) : '-',
		},
	];
};
